import axios from 'axios';
import apiConfig from '../../api.config';

export default async function invoiceGetListTemplate(hotelId, chainId, lang) {
  const {
    host,
    URIs: { invoiceGetListTemplate },
  } = apiConfig;

  const uri = `${host}${invoiceGetListTemplate}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId);

  return await axios.get(uri).then(res => res.data);
}
